// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"oQ-z","categoryName":"pQ-z","categoryNameSearchHeader":"qQ-z","categoryContent":"rQ-z","bottomAligned":"sQ-z","image":"tQ-z","imageNoBackground":"uQ-z"};